import type { CertiblokDocument } from "../../../interfaces/Document";
import type { TreeViewListItem } from "../types/ListItem";

export function computeRelativeElementIndex({ items, item }: { items: TreeViewListItem[]; item: TreeViewListItem }) {
	const parentFolder = item.parentFolder;
	let relativeIndex = 0;
	for (let i = 0; i < items.length && items[i].id !== item.id; i++) {
		const item = items[i];
		if (item.parentFolder.id === parentFolder.id) {
			relativeIndex++;
		}
	}

	return relativeIndex;
}
export function getLastElementOfFolderIndex({
	items,
	folder,
}: {
	items: TreeViewListItem[];
	folder: TreeViewListItem;
}) {
	let index = items.findIndex((item) => item.id === folder.id);

	while (
		index < items.length - 1 &&
		(items[index + 1].parentFolder.folderId === folder.item?.id ||
			items[index + 1].parentFolder.deepness - 1 >= folder.parentFolder.deepness)
	) {
		index++;
	}

	return index;
}

export function editMultipleDocuments({
	documents,
	itemsList,
}: {
	documents: CertiblokDocument[];
	itemsList: TreeViewListItem[];
}) {
	documents.forEach((document) => {
		const item = itemsList.find((item) => item.item?.id === document.id);
		if (item) {
			item.item = { ...document, isFolder: false };
		}
	});
}

export function computeNextFolderOnSameLevelIndex(startingIndex: number, itemsList: TreeViewListItem[]) {
	let nextFolderIndex = startingIndex;
	const item = itemsList[startingIndex];
	const parentFolder = item.parentFolder;
	let found = false;
	while (nextFolderIndex < itemsList.length - 1 && !found) {
		nextFolderIndex++;
		const currentItem = itemsList[nextFolderIndex];
		if (currentItem.parentFolder.deepness <= parentFolder.deepness) {
			found = true;
		}
	}
	if (nextFolderIndex === itemsList.length - 1 && !found) nextFolderIndex++;
	return nextFolderIndex;
}

export function getFolderDocuments(folderId: string, itemsList: TreeViewListItem[]): TreeViewListItem[] {
	// Get direct documents from current folder
	const directDocuments = itemsList.filter(
		(item) => item.parentFolder.folderId === folderId && !item.item?.isFolder && item.item
	);

	// Find all subfolders in current folder
	const subfolders = itemsList.filter((item) => item.parentFolder.folderId === folderId && item.item?.isFolder);

	// Recursively get documents from subfolders
	const subfoldersDocuments = subfolders.flatMap((folder) => getFolderDocuments(folder.item!.id, itemsList));

	// Combine direct documents with documents from subfolders
	return [...directDocuments, ...subfoldersDocuments] as TreeViewListItem[];
}
